import React, { Component } from 'react';
export default class About extends Component {
  render() {
    let resumeData = this.props.resumeData;
    return (
      <section id="about">
         <div className="row">

            <div className="three columns">

               <img className="profile-pic"  src="images/halil.jpeg" alt="" />

            </div>

            <div className="nine columns main-col">

               <h2>Over mij</h2>
               <p>Halil Montage is ervaren in de petrochemische sector en raffinaderijen. Met jarenlange expertise in montagewerkzaamheden biedt Halil betrouwbare en efficiënte oplossingen voor industriële installaties. <br/><br/>

Onze diensten omvatten onder andere het vervangen en installeren van appendages en leidingen, het monteren van technische installaties en het repareren van lekkages. Dankzij een nauwkeurige en doelgerichte aanpak zorgt Halil Montage voor veilige en duurzame oplossingen, afgestemd op de wensen van de klant.<br/><br/>

Op zoek naar een betrouwbare vakman voor uw industriële montagewerkzaamheden? Neem contact op met Halil Montage voor professioneel en vakkundig werk.</p>

               <div className="row">

                  <div className="columns contact-details">

                  <h2>Details</h2>
                  <p className="address">
       						<span>Halil Aktasoglu</span>
                     <br></br>
       						   <span>
                     Nederland
                    </span>
                    <br></br>
                    <span>Riderlaan 53A, 3074CC, Rotterdam</span><br></br>
                    <span>KVK: 77538714</span>
       					   </p>
                  </div>
               </div>
            </div>
         </div>
      </section>
    );
  }
}